import { useIsAuthenticated } from '@azure/msal-react';

export function useIsMsalAuth() {
  return useIsAuthenticated();
}
